"use strict";
var _SmallstackTypeRegistry_registeredTypes, _SmallstackTypeRegistry_registrationCallbacks;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallstackTypeRegistry = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("@smallstack/utils");
const pluralize_1 = require("pluralize");
const collection_names_1 = require("../collection-names");
const static_types_1 = require("./static-types");
const type_names_1 = require("./type-names");
class SmallstackTypeRegistry {
    constructor() {
        _SmallstackTypeRegistry_registeredTypes.set(this, Object.assign({}, ...static_types_1.StaticTypes.map((type) => ({ [this.tidyTypeName(type.name)]: type }))));
        _SmallstackTypeRegistry_registrationCallbacks.set(this, {});
    }
    addType(type) {
        const typeName = this.tidyTypeName(type.name);
        type.name = typeName;
        tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[typeName] = type;
        if (tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[type.name] instanceof Array) {
            console.warn("TypeRegistry", `The type "${typeName}" is now registered. ${tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[typeName].length} Callback(s) will be called now!`);
            for (const fn of tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[typeName])
                tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[typeName] = fn(type);
        }
    }
    removeType(name) {
        delete tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[name];
    }
    /** Helper method for removing all types that start with e.g. "custom_" */
    removeTypesStartingWith(startsWith) {
        for (const name of Object.keys(tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f"))) {
            if (name.startsWith(startsWith))
                delete tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[name];
        }
    }
    extendType(typeName, updateFn) {
        typeName = this.tidyTypeName(typeName);
        if (tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[typeName])
            void updateFn(tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[typeName]);
        else {
            console.warn("TypeRegistry", `The type "${typeName}" is not yet registered. Extending will happen once its registered.`);
            if (!tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[typeName])
                tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[typeName] = [];
            tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registrationCallbacks, "f")[typeName].push(updateFn);
        }
    }
    getI18nTitle(type, usePlural = false) {
        if (!type)
            throw new Error("No type given");
        return `@@types.${type.name}.${usePlural ? "plural" : "singular"}`;
    }
    getAllTypes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Object.values(tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f"));
        });
    }
    /** Returns the type by name or throws an exception */
    getTypeByName(name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // TODO: Find a common naming schema
            // exceptions
            if (name === type_names_1.T_CALENDAR_ENTRIES)
                name = collection_names_1.CollectionNames.COLLECTION_CALENDAR_ENTRIES;
            name = this.tidyTypeName(name);
            const type = tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")[name];
            if (type === undefined)
                throw new Error(`Type "${name}" not registered! Currently registered types are: ${Object.keys(tslib_1.__classPrivateFieldGet(this, _SmallstackTypeRegistry_registeredTypes, "f")).join(", ")}`);
            return type;
        });
    }
    filterTypes(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const allTypes = yield this.getAllTypes();
            return allTypes.filter((type) => {
                var _a;
                if ((options === null || options === void 0 ? void 0 : options.searchable) === true &&
                    (!(type.searchableFields instanceof Array) || type.toStringRepresentation === undefined))
                    return false;
                if ((options === null || options === void 0 ? void 0 : options.tags) instanceof Array) {
                    let foundOneTag = false;
                    for (const tag of options.tags)
                        if ((_a = type.tags) === null || _a === void 0 ? void 0 : _a.includes(tag)) {
                            foundOneTag = true;
                            break;
                        }
                    if (!foundOneTag)
                        return false;
                }
                return true;
            });
        });
    }
    toString(type, model) {
        if (!type)
            throw new Error("No type given!");
        if (type.toStringRepresentation === undefined)
            return model.id;
        if (!type.toStringRepresentation.includes(" "))
            return (0, utils_1.getJsonByPath)(model, utils_1.TextReplacer.extractKeys(type.toStringRepresentation)[0]);
        return utils_1.TextReplacer.replace(type.toStringRepresentation, model);
    }
    tidyTypeName(typeName) {
        return (0, pluralize_1.plural)((0, utils_1.snakeCaseToCamelCase)(typeName, false));
    }
}
exports.SmallstackTypeRegistry = SmallstackTypeRegistry;
_SmallstackTypeRegistry_registeredTypes = new WeakMap(), _SmallstackTypeRegistry_registrationCallbacks = new WeakMap();
